var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.48.6a.56.56 0 011.04 0l.73 1.8c.02.07.09.11.16.12l1.82.15c.5.04.7.65.33.98L6.17 4.87a.19.19 0 00-.06.18l.45 2.01c.1.5-.46.88-.88.58L4.11 6.52a.19.19 0 00-.22 0L2.32 7.64a.56.56 0 01-.88-.58l.45-2.01a.19.19 0 00-.06-.18L.44 3.65a.56.56 0 01.33-.98l1.82-.15c.07 0 .14-.05.16-.12L3.48.6z"
  })));
}

export default SvgStarIcon;